import { useLocation, useNavigate } from "react-router-dom";
import { TabsController } from "../context/tabsContext";

const useTabs = (count: number, urlParameterName?: string): TabsController => {
  const tab = urlParameterName ?? "tab";
  const navigate = useNavigate();
  const location = useLocation();

  // Read straight from the URL on every render, or default to 0 if it's invalid. Mirroring it into
  // state via an effect lagged one render behind the URL, so anything reading selectedIndex (e.g.
  // back/next buttons) briefly showed the previous tab's state after each switch.
  const urlIndex = Number(new URLSearchParams(location.search).get(tab));
  const selectedIndex = isNaN(urlIndex) ? 0 : urlIndex;

  const goToTab = (index: number) => {
    const params = new URLSearchParams(location.search);
    params.set(tab, `${index}`);
    navigate({ search: params.toString() });
  };

  const previous = () => selectedIndex > 0 && goToTab(selectedIndex - 1);
  const next = () => selectedIndex < count - 1 && goToTab(selectedIndex + 1);

  return { selectedIndex, goToTab, previous, next, urlParameter: tab };
};

export default useTabs;
